import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    filters: [],
    query: null,
    searchMeta: null,
    staffList: [],
    overridenStaffList: [],
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setFilters(state, filters) {
        state.filters = filters;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setOverridenStaffList(state, data) {
        state.overridenStaffList = data;
    },

    setStaffList(state, data) {
        state.staffList = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setOutletId(state, data) {
        state.outletId = data;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        startLoading(dispatch, 'get-price-override-meta');

        return axios
            .get(Laroute.route('franchise.report.price-override.meta'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-price-override-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-price-override-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getOverridenStaffListIfNecessary({ commit, dispatch }, params = {}) {
        if (
            params.outlet_id != state.outletId ||
            !state.overridenStaffList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);

            return dispatch('getOverridenStaffList', params);
        }

        return Promise.resolve(state.overridenStaffList);
    },

    getOverridenStaffList({ commit, dispatch }, params) {
        const route = Laroute.route(
            'franchise.report.price-override.overriden.staff',
        );

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-overriden-staff');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setOverridenStaffList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-overriden-staff');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-overriden-staff');
                throw err;
            });
    },

    getStaffListIfNecessary({ commit, dispatch }, params = {}) {
        if (
            params.outlet_id != state.outletId ||
            !state.staffList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);

            return dispatch('getStaffList', params);
        }

        return Promise.resolve(state.staffList);
    },

    getStaffList({ commit, dispatch }, params) {
        const route = Laroute.route(
            'franchise.report.price-override.cashier.staff',
        );

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-staff');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setStaffList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-staff');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-staff');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
